import type { ReactNode } from 'react';

import { OrderedList, OrderedListItem } from './styles';

type PartnerContent = {
  [partnerName: string]: {
    successBody?: ReactNode;
    successCTAText?: string;
    successCTAOnClick?: () => void;
    showDeliverToWorkOption?: boolean;
  };
};

export const PARTNER_ZIP_CHECK: PartnerContent = {
  allina: {
    successBody: (
      <>
        <b>Next Steps:</b>
        <br />
        <br />
        <OrderedList>
          <OrderedListItem>Return to Allina and select Capsule from the list of pharmacies.</OrderedListItem>
          <OrderedListItem>
            Once selected, Capsule will text you a link within an hour to set up your free, same-day delivery.
          </OrderedListItem>
          <OrderedListItem>
            Capsule will then deliver within a few hours. You (or someone you trust) will need to sign for it.
          </OrderedListItem>
        </OrderedList>
      </>
    ),
    successCTAText: 'Return to: Allina Health',
    // Product ask to close tab on success
    successCTAOnClick: () => window.close(),
    showDeliverToWorkOption: false,
  },
};
